import { put, call, take, fork } from 'redux-saga/effects'
import { patchPriceService } from '../../api/collection'
import {
  patchPriceSuccess,
  patchPriceError,
} from '../../reducers/collection/action'
import { PATCH_PRICE } from '../../reducers/collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 * @param {object} payload - Action payload
 * @param {string|number} payload.id - Price ID
 * @param {object} payload.data - Update data
 * @param {function} payload.callback - Optional callback
 */
function* patchPriceFlow(payload) {
  try {
    const { id, data, callback } = payload
    const response = yield call(patchPriceService, id, data)
    yield put(patchPriceSuccess(data))
    yield put(operationSuccess())

    if (callback) {
      callback()
    }
  } catch (error) {
    yield put(patchPriceError(error))
    yield put(operationFail(error))
  }
}

/**
 * Watches for PATCH_PRICE actions
 */
export default function* patchPriceWatcher() {
  while (true) {
    const action = yield take(PATCH_PRICE)
    const { payload } = action

    yield fork(generalSaga, patchPriceFlow, payload, false)
  }
}
